import { useState } from 'react'

import { EMPTY_FUNCTION_ASYNC } from '../../../../constants/common'
import { UserProfileWidgetPostAddress } from '../../../User'
import { Component, ComponentProps } from '../../Component'
import { boolean, controls, json } from '../../Controls'
import { MOCK_INFO_OPTIONS } from '../InhabitantProfile.constants'

import { PROFILE_POST_ADDRESS_INHABITANT_DATA } from './ProfilePostAddressWidgetInhabitant.constants'

function ProfilePostAddressWidgetInhabitant() {
  const [props, setProps] = useState(() =>
    controls() //
      .add(boolean('canEdit', true))
      .add(json('data', PROFILE_POST_ADDRESS_INHABITANT_DATA))
      .add(boolean('isSkeleton', false))
      .add(json('options', MOCK_INFO_OPTIONS))
  )

  return (
    <>
      <Component
        {...props.getValues()}
        Component={UserProfileWidgetPostAddress}
        name='UserProfileWidgetPostAddress'
        onSubmit={EMPTY_FUNCTION_ASYNC}
      />
      <ComponentProps
        name='UserProfileWidgetPostAddress'
        value={props}
        onChange={setProps}
      />
    </>
  )
}

export default ProfilePostAddressWidgetInhabitant
